
export default class EnvironmentDefs
{
    getEnv() {
        // return "dev";
        // return "devpoc";
        // return "devprod";
        // return "poc";
        // return "prod";
        return process.env.REACT_APP_AB_STACK;
    }

    isSmartlookActivated() {
        if (process.env.REACT_APP_SMARTLOOK && (process.env.REACT_APP_SMARTLOOK === "true")) {
            //NOTE: smartlook has a try / catch protection where it is used since it is imported on specific components only.
            return true;
        } else {
            return false;
        }
    }

    // Segment - not using for now, but leave hooks in
    isSegmentActive() {
        /*
        if (this.getEnv() === "prod") {
            if (window.analytics) {
                return true;
            } else {
                return false;
            }
        }

        if (this.getEnv() === "poc" || this.getEnv() === "devpoc" || this.getEnv() === "dev" || this.getEnv() === "devprod") {
            if (process.env.REACT_APP_SEGMENT && (process.env.REACT_APP_SEGMENT === "true")) {
                if (window.analytics) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        */
        return false;
    }

    // LeadDyno
    isLeadDynoActive() {
        if (this.getEnv() === "prod") {
            if (window.LeadDyno) {
                return true;
            } else {
                return false;
            }
        }

        if (this.getEnv() === "poc" || this.getEnv() === "devpoc" || this.getEnv() === "dev" || this.getEnv() === "devprod") {
            if (process.env.REACT_APP_LEADDYNO && (process.env.REACT_APP_LEADDYNO === "true")) {
                if (window.LeadDyno) {
                    return true;
                } else {
                    return false;
                }
            }
        }

        return false;
    }

    showACH() {
        if (this.getEnv() === "prod" || this.getEnv() === "devprod")
            return false;
        
        return true;
    }

    getDwollaEnv() {
        if (this.getEnv() === "prod" || this.getEnv() === "devprod")
            return "prod";
        
        return "sandbox";
    }

    getCoreWsUrl() {
        if (this.getEnv() === "prod" || this.getEnv() === "devprod")
            return 'https://ws.appbind.com/core/graphql';

        if (this.getEnv() === "poc" || this.getEnv() === "devpoc")
            return 'https://api.appbind.com/core/graphql';
        
        return 'http://localhost:5000/graphql';
    }

    getAuth0Domain() {
        if (this.getEnv() === "prod" || this.getEnv() === "devprod")
            return 'auth.appbind.com';
        
        if (this.getEnv() === "poc" || this.getEnv() === "devpoc")
            return 'authpoc.appbind.com';
        
        return 'authpoc.appbind.com';
    }

    getAuth0Client() {
        if (this.getEnv() === "prod" || this.getEnv() === "devprod")
            return '48bKekehwUk5v5t4DlmD6U6ezHaGDuW8';
        
        if (this.getEnv() === "poc" || this.getEnv() === "devpoc")
            return 'QQHwe5CrkIB0hpQQHwE9hpQo52djcK3y';
        
        return 'QQHwe5CrkIB0hpQQHwE9hpQo52djcK3y';
    }

    getBaseRedirect() {
        if (this.getEnv() === "prod")
            return 'https://app.appbind.com';
        
        if (this.getEnv() === "poc")
            return 'https://poc.appbind.com';
        
        if (this.getEnv() === "devprod" || this.getEnv() === "devpoc")
            return 'https://local.appbind.com:3000';
        
        return 'https://local.appbind.com:3000';
    }

    getAuth0RedirectUri() {
        if (this.getEnv() === "prod")
            return 'https://app.appbind.com/callback';
        
        if (this.getEnv() === "poc")
            return 'https://poc.appbind.com/callback';
        
        if (this.getEnv() === "devprod" || this.getEnv() === "devpoc")
            return 'https://local.appbind.com:3000/callback';
        
        return 'https://local.appbind.com:3000/callback';
    }

    getAuth0Audience() {
        if (this.getEnv() === "prod" || this.getEnv() === "devprod")
            return 'https://appbind-prod.auth0.com/userinfo';
        
        if (this.getEnv() === "poc" || this.getEnv() === "devpoc")
            return 'https://appbind.auth0.com/userinfo';
        
        return 'https://appbind.auth0.com/userinfo';
    }

    getPartnerApiUrl() {
        if (this.getEnv() === "prod" || this.getEnv() === "devprod")
            return 'https://ws.appbind.com/partner/';
        
        if (this.getEnv() === "poc" || this.getEnv() === "devpoc")
            return 'https://api.appbind.com/partner/';
        
        return 'https://api.appbind.com/partner/';
    }

    getSkey() {
        if (this.getEnv() === "prod" || this.getEnv() === "devprod")
            return 'pk_live_VDA9McBVyPUOSUTWNjDPQTP5';
        
        if (this.getEnv() === "poc" || this.getEnv() === "devpoc")
            return 'pk_test_ZRvtfkvblKPhOw3D1sosTdhO';
        
        return 'pk_test_ZRvtfkvblKPhOw3D1sosTdhO';
    }
    
    //return smartlook keys
    getSmartlookKey() {
        if (this.getEnv() === "prod" || this.getEnv() === "devprod") {
            return '81482478f7945d9a9e3ab4ec4c64ac09f9696b86';
        }
        
        if (this.getEnv() === "poc" || this.getEnv() === "devpoc") {
            if (this.isSmartlookActivated()) {
                return '22f83f5653cc39cb8be3a2b0c1ee9ca8214aa31f';
            } else {
                return null;
            }
        }
       
        //dev account
        if (this.getEnv() === "dev") {
           if (this.isSmartlookActivated()) {
               return '024333ccb88fda56c04bb693d7394c46893a66c4';
           } else {
               return null;
           }
        }
    }
}